import Title from '@/components/Title';
import React from 'react';
import { i18n, useTranslation } from 'next-i18next';
import Image from 'next/image';
import cls from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import LeadButton from '@/components/LeadButton';
import TPLink from '@/components/TPLink';

const GoodReputation = () => {
  const { t } = useTranslation(['home', 'math']);

  return (
    <>
      <div className="container relative mt-[80px]">
        <div className="relative justify-center lg:flex xl:flex">
          <Title className="relative xl:mt-[200px]" innerHTML theme="math">
            {`${t('math:好口碑-标题', { tag: '' })}
          <div class="absolute right-[-100px] top-[-45px] hidden h-[80px] w-[80px] shrink-0 items-center justify-center rounded-[20px] bg-[linear-gradient(135deg,rgba(255,255,255,0.56)_0%,#FFF_100%)] shadow-[0px_33px_50px_0px_rgba(0,0,0,0.06)] rotate-[-15deg] lg:flex xl:flex">
                <img class="w-[49px]" src="/images/english/heart.png" alt="" />
          <img class="absolute right-[-30px] top-[20px] w-[39px]" src="/images/english/rectangle.png" alt="" />
        </div>`}
          </Title>
        </div>
        <TPLink>
          <p className="mb-6 mt-6 flex items-center justify-center text-xs lg:mt-5 lg:justify-center  lg:text-sm xl:mt-[22px] xl:text-xl">
            <span className="mr-2">Trustpilot</span>
            <span className="h-[14px] w-[81px] lg:h-4 lg:w-[92px] xl:h-[20px] xl:w-[115px]">
              <Image alt="WuKong userReviews" width={115} height={20} src="/images/home/userReviews-tp2.jpg" />
            </span>
            <span className="ml-2" dangerouslySetInnerHTML={{ __html: t('home:banner-tp-1') }} />
          </p>
        </TPLink>
        <div className="mt-[116px] hidden justify-between lg:flex xl:flex">
          <div
            className={cls(
              'relative rounded-[36px] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)] lg:w-[312px] xl:w-[440px]',
              i18n?.language === 'zh' ? 'lg:h-[324px] xl:h-[372px]' : 'lg:h-[443px] xl:h-[427px]',
            )}
          >
            <Image
              className="sm:hidden md:hidden lg:hidden xl:block"
              src={i18n?.language === 'zh' ? '/images/math/appraise1_xl_cn.png' : '/images/math/appraise1_xl_en.png'}
              fill
              alt="WuKong"
            />
            <Image
              className="sm:hidden md:hidden lg:block xl:hidden"
              src={i18n?.language === 'zh' ? '/images/math/appraise1_lg_cn.png' : '/images/math/appraise1_lg_en.png'}
              fill
              alt="WuKong"
            />
            <div className="absolute lg:left-[-14px] lg:top-[-54px] lg:h-[88px] lg:w-[88px] xl:left-[-16px] xl:top-[-56px] xl:h-[112px] xl:w-[112px]">
              <Image
                className="hidden rounded-[50%] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)] lg:block"
                src="/images/math/appraise1_avatar.png"
                fill
                alt="Students of WuKong Math"
              />
            </div>
          </div>
          <div
            className={cls(
              'relative rounded-[36px] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)] lg:w-[312px] xl:w-[440px]',
              i18n?.language === 'zh' ? 'lg:h-[324px] xl:h-[372px]' : 'lg:h-[443px] xl:h-[427px]',
            )}
          >
            <Image
              className="sm:hidden md:hidden lg:hidden xl:block"
              src={i18n?.language === 'zh' ? '/images/math/appraise2_xl.png' : '/images/math/appraise2_xl_en.png'}
              fill
              alt="WuKong"
            />
            <Image
              className="sm:hidden md:hidden lg:block xl:hidden"
              src={i18n?.language === 'zh' ? '/images/math/appraise2_lg.png' : '/images/math/appraise2_lg_en.png'}
              fill
              alt="WuKong"
            />
            <div className="absolute lg:left-[-14px] lg:top-[-54px] lg:h-[88px] lg:w-[88px] xl:left-[-16px] xl:top-[-56px] xl:h-[112px] xl:w-[112px]">
              <Image
                className="hidden rounded-[50%] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)] lg:block"
                src="/images/math/appraise2_avatar.png"
                fill
                alt="Students of WuKong Math"
              />
            </div>
          </div>
          <div
            className={cls(
              'relative rounded-[36px] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)] lg:w-[312px] xl:w-[440px]',
              i18n?.language === 'zh' ? 'lg:h-[324px] xl:h-[372px]' : 'lg:h-[443px] xl:h-[427px]',
            )}
          >
            <Image
              className="sm:hidden md:hidden lg:hidden xl:block"
              src={i18n?.language === 'zh' ? '/images/math/appraise3_xl_cn.png' : '/images/math/appraise3_xl_en.png'}
              fill
              alt="WuKong"
            />
            <Image
              className="sm:hidden md:hidden lg:block xl:hidden"
              src={i18n?.language === 'zh' ? '/images/math/appraise3_lg_cn.png' : '/images/math/appraise3_lg_en.png'}
              fill
              alt="WuKong"
            />
            <div className="absolute lg:left-[-14px] lg:top-[-54px] lg:h-[88px] lg:w-[88px] xl:left-[-16px] xl:top-[-56px] xl:h-[112px] xl:w-[112px]">
              <Image
                className="hidden rounded-[50%] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)] lg:block"
                src="/images/math/appraise3_avatar.png"
                fill
                alt="Students of WuKong Math"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className={cls(
          'relative mt-[54px] w-full lg:hidden xl:hidden',
          // i18n?.language === 'zh' ? ' h-[291px]' : 'h-[377px]',
        )}
      >
        <Swiper
          style={{ paddingLeft: '8px' }}
          spaceBetween={0}
          slidesPerView="auto"
          onSwiper={(swiper) => console.log(swiper)}
        >
          <SwiperSlide className="w-[82%!important] rounded-[24px]">
            <div className="relative w-full">
              <div className="h-[66px] w-[66px] rounded-[50%] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)]">
                <Image
                  src="/images/math/appraise1_avatar.png"
                  className="h-auto w-full"
                  height={0}
                  width={0}
                  sizes="100vw"
                  alt="WuKong"
                />
              </div>
              <div
                className={cls(
                  'absolute left-[12px] top-[32px] z-[-1] w-[280px] rounded-[24px] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)]',
                  i18n?.language === 'zh' ? ' h-[291px]' : 'h-[377px]',
                )}
              >
                <Image
                  src={i18n?.language === 'zh' ? '/images/math/appraise1_m_cn.png' : '/images/math/appraise1_m_en.png'}
                  className="h-auto w-full"
                  height={0}
                  width={0}
                  sizes="100vw"
                  alt="WuKong"
                />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="w-[80%!important] rounded-[24px]">
            <div className={cls('relative w-full', i18n?.language === 'zh' ? 'h-[353px]' : 'h-[439px]')}>
              <div className="h-[66px] w-[66px] rounded-[50%] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)]">
                <Image
                  src="/images/math/appraise2_avatar.png"
                  className="h-auto w-full"
                  height={0}
                  width={0}
                  sizes="100vw"
                  alt="WuKong"
                />
              </div>
              <div
                className={cls(
                  'absolute left-[12px] top-[32px] z-[-1] w-[280px] rounded-[24px] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)]',
                  i18n?.language === 'zh' ? ' h-[291px]' : 'h-[377px]',
                )}
              >
                <Image
                  src={i18n?.language === 'zh' ? '/images/math/appraise2_m.png' : '/images/math/appraise2_m_en.png'}
                  className="h-auto w-full"
                  height={0}
                  width={0}
                  sizes="100vw"
                  alt="WuKong"
                />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="w-[80%!important] rounded-[24px]">
            <div className="relative w-full">
              <div className="h-[66px] w-[66px] rounded-[50%] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)]">
                <Image
                  src="/images/math/appraise3_avatar.png"
                  className="h-auto w-full"
                  height={0}
                  width={0}
                  sizes="100vw"
                  alt="WuKong"
                />
              </div>
              <div
                className={cls(
                  'absolute left-[12px] top-[32px] z-[-1] w-[280px] rounded-[24px] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)]',
                  i18n?.language === 'zh' ? ' h-[291px]' : 'h-[377px]',
                )}
              >
                <Image
                  src={i18n?.language === 'zh' ? '/images/math/appraise3_m_cn.png' : '/images/math/appraise3_m_en.png'}
                  className="h-auto w-full"
                  height={0}
                  width={0}
                  sizes="100vw"
                  alt="WuKong"
                />
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className="text-center lg:mt-15 xl:mt-20">
        <LeadButton
          theme="math"
          size="xl"
          subject="math"
          className=""
          traceName="O_MathCourse_WordOfMouth_CTAClick"
          traceGa4Name="new_entry_WordOfMouthCTA"
        >
          {t('math:math-按钮')}
        </LeadButton>
      </div>
    </>
  );
};

export default GoodReputation;
